import * as R from 'ramda'
export const pickUserProfileApi = R.pick([
  'firstName',
  'lastName',
  'email',
  'countryCode',
  'phoneNumber',
  'avatar',
  'languageId',
  'localizationLanguageId',
])

export const mapEmptyPhoneNumber = R.when(
  R.compose(R.isNil, R.prop('phoneNumber')),
  R.mergeLeft({ countryCode: null, phoneNumber: null }),
)
